import { TaskTrackerSearchUser } from '../lib/projectMember.types'
import {
  TaskTrackerCatalogUser,
  TaskTrackerMemberSearchUser,
  TaskTrackerTrackerUserRecord,
} from '../lib/taskTrackerUser.types'
import { ApiCatalogUser, ApiSearchUser, ApiTrackerUserRecord } from './taskTracker.api.types'

export const mapLmsSearchUserFromApi = (
  item: ApiSearchUser,
): TaskTrackerMemberSearchUser => ({
  id: Number(item.id),
  name: String(item.name ?? '').trim(),
  email: item.email ?? null,
  phone: item.phone ?? null,
  avatarPath: item.avatar_path ?? null,
  roles: Array.isArray(item.roles) ? item.roles.map(String) : [],
  isAddedToTaskTracker: Boolean(item.is_added_to_task_tracker),
})

export const mapSearchUserFromApi = (
  item: ApiSearchUser,
): TaskTrackerSearchUser => mapLmsSearchUserFromApi(item)

export const mapCatalogUserFromApi = (
  item: ApiCatalogUser,
): TaskTrackerCatalogUser => ({
  id: Number(item.id),
  trackerUserId: Number(item.tracker_user_id),
  name: String(item.name ?? '').trim(),
  email: item.email ?? null,
  phone: item.phone ?? null,
  avatarPath: item.avatar_path ?? null,
})

export const mapCatalogUserToMemberSearchUser = (
  item: ApiCatalogUser,
): TaskTrackerMemberSearchUser => {
  const catalogUser = mapCatalogUserFromApi(item)

  return {
    id: catalogUser.id,
    name: catalogUser.name,
    email: catalogUser.email,
    phone: catalogUser.phone,
    avatarPath: catalogUser.avatarPath,
  }
}

export const mapTrackerUserRecordFromApi = (
  item: ApiTrackerUserRecord,
): TaskTrackerTrackerUserRecord => ({
  id: Number(item.id),
  userId: Number(item.user_id),
  name: String(item.name ?? '').trim(),
  email: item.email ?? null,
  phone: item.phone ?? null,
  avatarPath: item.avatar_path ?? null,
})

export const mapTrackerUserRecordToCatalogUser = (
  item: TaskTrackerTrackerUserRecord,
): TaskTrackerCatalogUser => ({
  id: item.userId,
  trackerUserId: item.id,
  name: item.name,
  email: item.email,
  phone: item.phone,
  avatarPath: item.avatarPath,
})
